/**
 * SAMURAI TCG - Toast Notification Module
 */

(function () {
  'use strict';

  const TCGToast = {
    _timeout: null,

    /**
     * Show a toast notification
     * @param {string} message - Message to display
     * @param {string} type - 'success' | 'error' | 'info'
     * @param {number} duration - Duration in ms (default: 2500)
     */
    show(message, type = 'success', duration = 2500) {
      const toast = document.getElementById('tcg-toast');
      if (!toast) return;

      // Clear any existing timeout
      if (this._timeout) {
        clearTimeout(this._timeout);
        toast.classList.remove('is-visible');
      }

      // Set icon based on type
      const icons = {
        success: '✓',
        error: '✕',
        info: 'ℹ',
      };

      // textContent固定: 商品名やサーバー由来メッセージが渡るためHTML解釈させない(XSS対策)
      toast.textContent = `${icons[type] || '✓'} ${message}`;
      toast.style.background =
        type === 'error' ? '#dc2626' : type === 'info' ? '#2563eb' : '#1e293b';

      // Show with slight delay for CSS transition
      requestAnimationFrame(() => {
        toast.classList.add('is-visible');
      });

      // Hide after duration
      this._timeout = setTimeout(() => {
        toast.classList.remove('is-visible');
        this._timeout = null;
      }, duration);
    },
  };

  // Expose globally
  window.TCGToast = TCGToast;
})();
